import { apiFetch } from "../../services/api-fetch";
import Toast from "../modal/toast";
import * as validator from "../../services/validator/index";

class AjaxForm {
  constructor(form, config = {}) {
    this.form = form;

    this.beforeValidationCallback = config.beforeValidation;
    this.beforeSubmitCallback = config.beforeSubmit;
    this.afterSubmitCallback = config.afterSubmit;
    this.onErrorCallback = config.onError;
    this.onRequestErrorCallback = config.onRequestError;
    this.onNetworkErrorCallback = config.onNetworkError;
    this.handleErrors = config.handleErrors;

    this.validationRules = config.validationRules || {};

    this.submitButton = this.form.querySelector('[type="submit"]');

    this.form.addEventListener("submit", e => {
      e.preventDefault();

      this.onSubmit();
    });

    this.form.addEventListener("change", e => this._bgValidate());
    this.save();
  }

  save() {
    this._savedState = this.state;
  }

  get savedState() {
    return this._savedState; 
  }

  get state() {
    return new FormData(this.form);
  }

  onSubmit() {
    if (typeof this.beforeValidationCallback === "function") {
      this.beforeValidationCallback.call(this);
    }
    if (this.validate("showErrors")) {
      this.submit();
    }
  }

  _bgValidate() {
    if(this.form.classList.contains('has-errors')) {
      this.validate("showErrors");
    }
  }

  validate(showErrors) {
    let errors = validator.validateForm(this.form, this.validationRules);

    if (!errors) {
      validator.hideErrors(this.form);
      return true;
    }

    if (showErrors) {
      if (this.handleErrors) {
        this.handleErrors(errors, this.form);
      }
      else {
        validator.hideErrors(this.form);
        validator.showErrors(this.form, errors, "scroll");
      }
    }

    return false;
  }

  submit() {
    if (this.submitButton) {
      this.submitButton.setAttribute('data-loading', '');
      this.submitButton.disabled = true;
    }

    let data = this.state;

    if (typeof this.beforeSubmitCallback === "function") {
      data = this.beforeSubmitCallback.call(this, data);
    }

    apiFetch(this.form.action, {
      method: "POST",
      body: data
    })
    .then(response => {
      this.submitButton.removeAttribute('data-loading');
      this.submitButton.disabled = false;

      if (response.success) {
        this.save();
        if (response.message) {
          Toast.open(response.message, { state: "success" });
        }
        if (typeof this.afterSubmitCallback === "function") {
          this.afterSubmitCallback.call(this, response);
        }
      } else {
        if (response.validation) {
          if (this.handleErrors) {
            this.handleErrors(response.validation, this.form);
          }
          else {
            validator.hideErrors(this.form);
            validator.showErrorsByNames(this.form, response.validation, this.validationRules);
          }
          return;
        }
        if (response.error) {
          Toast.open(response.error, { state: "error" });
        }
        if (response.errors) {
          if (this.handleErrors) {
            this.handleErrors(response.errors, this.form);
          }
          else {
            validator.showCommonErrors(this.form, response.errors);
          }
        }
        if (typeof this.onRequestErrorCallback === "function") {
          this.onRequestErrorCallback.call(this, response.error, response);
        }
        if (typeof this.onErrorCallback === "function") {
          this.onErrorCallback.call(this, response.error, response);
        }
      }
    })
    .catch(err => {
      console.error(err);
      this.submitButton.removeAttribute('data-loading');
      this.submitButton.disabled = false;
      if (typeof this.onNetworkErrorCallback === "function") {
        this.onNetworkErrorCallback.call(this, err);
      }
      if (typeof this.onErrorCallback === "function") {
        this.onErrorCallback.call(this, err);
      }
    })
  }
}

export default AjaxForm;